module.exports = __webpack_public_path__ + "static/media/arrow_right.5b1604d4.svg";